import "./QrCodeStation.css";
import { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import QrScanner from "qr-scanner";
import dayjs from "dayjs";
import { getStationTopic, scanStationQR, scanTrayQR } from "./services";
import { toast, ToastContainer } from "react-toastify";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import Button from "../../components/Button/Button";
import { useSelector } from "react-redux";

const QrCodeStation = ({ scanType, setScanStation, setTrayQrScan }) => {
  const [loadingScan, setLoadingScan] = useState(true);
  const [data, setData] = useState("");
  const [scanTrayData, setScanTrayData] = useState({});
  const navigate = useNavigate();
  const [isScanning, setIsScanning] = useState(false);
  const videoRef = useRef(null);
  const qrScannerRef = useRef(null);
  const [isStrippingPopup, setStrippingPopup] = useState(false);
  const [lastScannedCode, setLastScannedCode] = useState("");
  console.log("scanType=>rwerwerew", data);
  var myScanType = scanType;
  const { userPermission } = useSelector((state) => state.userState);
  const location = useLocation();
  const batchIdData = location?.state?.batch_types;
  const scanTypeRef = useRef(scanType);

  console.log("batchIdData", batchIdData);

  useEffect(() => {
    localStorage.removeItem("is_station_qr");
  }, []);

  useEffect(() => {
    scanTypeRef.current = scanType;
  }, [scanType]);

  useEffect(() => {
    const initQrScanner = async () => {
      if (videoRef.current) {
        qrScannerRef.current = new QrScanner(
          videoRef.current,
          (result) => handleScan(result),
          {
            onDecodeError: handleError,
            highlightScanRegion: true,
            highlightCodeOutline: true,
          }
        );
        await qrScannerRef.current.start();
      }
    };

    initQrScanner();

    return () => {
      if (qrScannerRef.current) {
        qrScannerRef.current.stop();
        qrScannerRef.current.destroy();
      }
    };
  }, []);

  // const handleScan = async (scanData) => {
  //   if (!scanData || isScanning) return; // Prevent multiple API calls

  //   setIsScanning(true); // Lock scanning process
  //   const scanTime = new Date().toISOString();
  //   const TimeFormat = dayjs(scanTime).format("hh:mm:ss");
  //   const dateFormat = dayjs(scanTime).format("DD/MM/YYYY");

  //   setData(scanData);

  //   const existingScans = JSON.parse(localStorage.getItem("qrScans")) || [];
  //   const scanIndex = existingScans.findIndex((scan) => scan.type === scanType);
  //   console.log("scanIndex::", scanIndex)
  //   const newScan = {
  //     type: scanType,
  //     data: scanData,
  //     time: TimeFormat,
  //     date: dateFormat,
  //   };

  //   if (scanIndex !== -1) {
  //     existingScans[scanIndex] = newScan;
  //   } else {
  //     existingScans.push(newScan);
  //   }

  //   localStorage.setItem("qrScans", JSON.stringify(existingScans));
  //   const scanTypeValue = scanTypeRef.current;  // Use ref value instead
  //   console.log("Using scanTypeRef:", scanTypeValue);

  //   try {
  //     console.log("scanType::", scanType);
  //     console.log("myScanType::", myScanType);

  //     if (scanTypeValue === "tray") {
  //       console.log("handle tray")
  //       await handleScanTray(scanData);
  //     } else if (scanTypeValue === "station") {
  //       console.log("handle station")
  //       await handleScanStation(scanData);
  //     }
  //   } catch (error) {
  //     console.error("Error in scanning", error);
  //   } finally {
  //     setIsScanning(false); // Unlock scanning process
  //     setLoadingScan(false);
  //   }
  // };

  let isCooldownActive = false; // Prevent multiple scans within the cooldown period

  const handleScan = async (scanData) => {
    const productionLinePermission = userPermission.find(
      (permission) => permission.module === "Production Line"
    );
    
    if (!productionLinePermission?.is_editor || !productionLinePermission?.is_viewer) {
      toast.error("You don't have access to scan QR codes");
      return;
    }
    
    if (!scanData || isScanning || isCooldownActive) return;

    setIsScanning(true);
    isCooldownActive = true;
    
    const scanTime = new Date().toISOString();
    const TimeFormat = dayjs(scanTime).format("hh:mm:ss");
    const dateFormat = dayjs(scanTime).format("DD/MM/YYYY");

    setData(scanData);

    const existingScans = JSON.parse(localStorage.getItem("qrScans")) || [];

    const scanTypeValue = scanTypeRef.current; // Use ref value instead

    const newScan = {
      type: scanTypeValue,
      data: scanData,
      time: TimeFormat,
      date: dateFormat,
    };
    if (scanData) { // Check if scanData is not empty
      existingScans.push(newScan);
      localStorage.setItem("qrScans", JSON.stringify(existingScans));
    }

    try {
      if (scanTypeValue === "tray") {
        await handleScanTray(scanData);
      } else if (scanTypeValue === "station") {
        const trayScan = existingScans.find((scan) => scan.type === "tray");
        if (!trayScan) {
          toast.error("Please scan a tray QR first.");
          setIsScanning(false);
          isCooldownActive = false;
          return;
        }
        await handleScanStation(scanData);
      }
    } catch (error) {
      console.error("Error in scanning", error);
    } finally {
      setTimeout(() => {
        isCooldownActive = false;
        console.log("Cooldown ended, ready for next scan.");
      }, 5000);
      setIsScanning(false);
    }
  };
  const existingScans = JSON.parse(localStorage.getItem("qrScans")) || [];
  const trayScan = existingScans.findLast((scan) => scan.type === "tray"); // Get latest tray QR
  const StationScan = existingScans.findLast((scan) => scan.type === "station"); // Get latest tray QR

  const handleScanTray = async (qr_code, manual) => {
    const productionLinePermission = userPermission.find(
      (permission) => permission.module === "Production Line"
    );
    
    if (!productionLinePermission?.is_editor || !productionLinePermission?.is_viewer) {
      toast.error("You don't have access to scan QR codes");
      return;
    }

    setData(qr_code);
    const params = {
      qr_code: qr_code.data,
      is_manual_batch: manual
    };
 
    try {
      const resp = await scanTrayQR(params);
      if (resp.status === 200 || resp.status === 201) {
        toast.success(resp.data.message, { autoClose: 5000 });
        const {
          is_out_feed_station,
          batch_id,
          is_station_qr,
          station_name,
          station_topic,
          batch_type,
          scanned_machine,
          is_tray_qr,
          is_stripping_station,
          is_manual_batch,
          is_stripping_out,
          tray_assigned_batch
        } = resp.data.payload;

        setScanTrayData(resp.data.payload);
        setTrayQrScan(is_tray_qr);

        localStorage.setItem("is_station_qr", is_station_qr ? true : false);
        if(tray_assigned_batch !== undefined){
          localStorage.setItem("tray_assigned_batch", JSON.stringify(tray_assigned_batch));
        }
    
       

        if (is_out_feed_station) {
          navigate(`/feed-visual-inspection/${batch_id}`);
        } else if (is_stripping_station) {
          navigate("/production-line-stripping", {
            state: {
              manualBatch: is_manual_batch,
              isautobatch : true
            },
          });
        }
        if ((station_name == "Stripping" || scanned_machine == "Stripping") && !is_stripping_out ) {
          setStrippingPopup(true);
          return;
        } else if (is_station_qr) {
          localStorage.setItem("batch_id", JSON.stringify(batch_id));
          localStorage.setItem("batch_type", JSON.stringify(batch_type));

          navigate(`/production-line-chart`, {
            state: {
              batch_types: batch_id,
              stationName: station_name,
              stationTopic: station_topic,
              scannedMachine: scanned_machine,
              batch_type: batch_type,
            },
          });
          // localStorage.setItem(
          //   "qrPayload",
          //   JSON.stringify(resp.data.payload)
          // );
        } else {
          localStorage.setItem("batch_id", JSON.stringify(batch_id));
          setScanStation(true);

          // localStorage.setItem("setScanStation", JSON.stringify(false));
          // setScanStation(true);
        }

        // Tray QR localStorage ma store karo
        const existingScans = JSON.parse(localStorage.getItem("qrScans")) || [];
        const newScan = {
          type: "tray",
          data: qr_code,
          is_station_qr: is_station_qr,
        };
        const scanIndex = existingScans.findIndex(
          (scan) => scan.type === "tray"
        );

        if (scanIndex !== -1) {
          existingScans[scanIndex] = newScan;
        } else {
          existingScans.push(newScan);
        }
        localStorage.setItem("qrScans", JSON.stringify(existingScans));
      }
    } catch (error) {
      toast.error(error.response.data.message);
      setScanTrayData([]);
    }
  };
  const ScanStation = location?.state?.scanStation !== undefined ? true : false;
  const supervisor_name = location?.state?.supervisor_name;
  const batchId = location?.state?.batchId;
  const operator_name = localStorage.getItem("operatorNameData");
  const batchData = JSON.parse(localStorage.getItem("batchIdData"));

  let batchIdDataQr = [];
  let selectBatch = [];

  try {
    const storedBatchData = localStorage.getItem("batch_id");
    batchIdDataQr = storedBatchData ? JSON.parse(storedBatchData) : [];
  } catch (error) {
    console.error("Error parsing batch_id from localStorage:", error);
    batchIdDataQr = []; // Fallback to empty array
  }

  try {
    const storedBatchData = localStorage.getItem("selectBatch");
    selectBatch = storedBatchData ? JSON.parse(storedBatchData) : [];
  } catch (error) {
    console.error("Error parsing batch_id from localStorage:", error);
    selectBatch = []; // Fallback to empty array
  }

  console.log(batchIdDataQr); // Always returns an array (never undefined)
  console.log(
    "batchIdbatchIdbatchIdbatchId",
    batchId,
    batchData,
    batchIdDataQr,
    ScanStation
  );

  const handleScanStation = async (station_qr_code) => {
    const productionLinePermission = userPermission.find(
      (permission) => permission.module === "Production Line"
    );
    
    if (!productionLinePermission?.is_editor || !productionLinePermission?.is_viewer) {
      toast.error("You don't have access to scan QR codes");
      return;
    }

    if (!trayScan) {
      console.error("No tray QR found!");
      return;
    }
    let { data: trayQrData, is_station_qr } = trayScan;

    let params = {};

    if (is_station_qr == true && ScanStation == true) {
      params = {
        tray_qr_code: station_qr_code.data,
        station_qr_code: trayQrData.data,
        batch_ids:
          batchId?.length > 0
            ? batchId
            : batchData?.length > 0
            ? batchData
            : selectBatch.length > 0
            ? selectBatch
            : batchIdDataQr,
        ...(operator_name && { operator: operator_name }),
        ...(supervisor_name && { supervisor: supervisor_name }),
      };
    } else if (is_station_qr == true) {
      params = {
        tray_qr_code: station_qr_code.data,
        station_qr_code: trayQrData.data,
        batch_ids: JSON.parse(localStorage.getItem("batch_id")),
        ...(operator_name && { operator: operator_name }),
        ...(supervisor_name && { supervisor: supervisor_name }),
      };
    } else if (ScanStation) {
      params = {
        tray_qr_code: station_qr_code.data, // Use latest stored tray QR
        station_qr_code: trayQrData.data,
        batch_ids:
          batchId?.length > 0
            ? batchId
            : batchData?.length > 0
            ? batchData
            : selectBatch.length > 0
            ? selectBatch
            : batchIdDataQr,
        ...(operator_name && { operator: operator_name }),
        ...(supervisor_name && { supervisor: supervisor_name }),
      };
    } else {
      params = {
        tray_qr_code: trayScan.data.data, // Use latest stored tray QR
        station_qr_code: station_qr_code.data,
        batch_ids: JSON.parse(localStorage.getItem("batch_id")),
      };
    }

    try {
      const resp = await scanStationQR(params);
      if (resp.status === 200 || resp.status === 201) {
        toast.success(resp.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

        localStorage.setItem("is_station_qr", false);
        const {
          is_stripping_station,
          batch_id,
          station_name,
          previous_station,
          station_topic,
          transferred_to,
          tray_qr_code,
          scanned_machine,
          batch_type,
        } = resp.data.payload;

        // Retrive stored station logs from localStorage
        let stationLogs = JSON.parse(localStorage.getItem("stationLogs")) || [];

        // Create a new log entry
        const newLog = {
          station_name,
          transferred_to,
          tray_qr_code,
        };

        // Add new entry to the array
        stationLogs.push(newLog);

        // Store updated logs in localStorage
        localStorage.setItem("stationLogs", JSON.stringify(stationLogs));
        localStorage.setItem("batch_id", JSON.stringify(batch_id));

        if (is_stripping_station) {
          navigate("/production-line-stripping");
        } else {
          if (batch_id) {
            navigate(`/production-line-chart`, {
              state: {
                batch_types: batch_id,
                stationName: station_name,
                prevStation: previous_station,
                stationTopic: station_topic,
                scannedMachine: scanned_machine,
                batch_type: batch_type,
              },
            });
            // localStorage.setItem(
            //   "qrPayload",
            //   JSON.stringify(resp.data.payload)
            // );
          }
        }
      }
    } catch (error) {
      toast.error(error.response.data.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.error("Error scanning station", error);
      // ⏸️ Pause scanning for 5 seconds after an error
      setIsScanning(true); // Keep scanning locked
      setTimeout(() => setIsScanning(false), 5000); // Unlock after 5s
    }
  };

  const handleError = (err) => {
    // console.error(err);
    setLoadingScan(false);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoadingScan(false);
    }, 3000);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="App">
      <ToastContainer />
      <video ref={videoRef} style={{ width: "400px" }} />

      <Dialog open={isStrippingPopup} fullWidth>
        <DialogTitle className="productionline-dialog-title">
          STRIPPING STATION
        </DialogTitle>
        <DialogContent className="mt-3">
          <div
            className="d-flex pt-3 justify-content-center gap-4 align-items-center"
            style={{ height: "150px" }}
          >
            <div className="text-center d-flex flex-column align-items-center">
              <Button
                title="SCAN IN"
                className="submit-button common-button mb-1"
                onClick={() => handleScanTray(trayScan.data, true)}
              />
              <p className="m-0 small">(Manual Batch Only)</p>
            </div>
            <div
              className="text-center d-flex flex-column align-items-center "
              style={{ marginTop: "-24px" }}
            >
              <Button
                title="SCAN OUT"
                className="submit-button common-button"
                onClick={() => handleScanTray(trayScan.data, false)}
              />
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default QrCodeStation;
